/* global akamai */
import get from 'lodash/get';

export const GetRegion = () => localStorage.getItem('loginInfo.region');

export const AKAMAI = get(window, 'akamai', '');
export const LOCAL_STORAGE_USERHASH = 'loginInfo.userhash';
export const LOCAL_STORAGE_USER_DATA = 'loginInfo.logged_user_data';
export const LOCAL_STORAGE_USER_TOKEN = 'loginInfo.userToken';
export const LOCAL_STORAGE_REGION = 'loginInfo.region';
export const LOCAL_STORAGE_LOGGED_USER = 'loginInfo.logged_user';
export const LOCAL_STORAGE_FAVORITES = 'favorites';
export const LOCAL_STORAGE_LAST_CHANNEL_SEEN = 'cv.LAST_CHANNEL_SEEN';
export const ANONYMOUS_USER = 'ANONYMOUS';
export const NOSUSC_USER = 'NO_SUSC';
export const SUSC_USER = 'SUSC';

export const FREE_TYPE = 'free';

export const SUSC_TYPE = 'susc';

export const USER_DATA_LOGOUT_FORCE = 'logOutForce';

export const NINIOS_CODE = 'ninios';
export const UNKNOWN_LAYOUT = 'unknown';
export const OLD_EXPERIENCE = 'oldexperience';
export const GUIDECHANNELS_LAYOUT = 'guidechannels';

export const USER_DATA_USERID = 'user_id';
export const USER_DATA_USERNAME = 'username';
export const USER_DATA_FIRSTNAME = 'firstname';
export const USER_DATA_LASTNAME = 'lastname';
export const USER_DATA_SAVEDPAYWAY = 'hasSavedPayway';
export const USER_DATA_HASUSERSUC = 'hasUserSusc';
export const USER_DATA_ACCEPTEDTERMS = 'acceptedTerms';
export const USER_DATA_GAMIFICATIONID = 'gamification_id';
export const USER_IS_NET_USER = 'netIsUser';
export const USER_DATA_TOKEN = 'token';
export const SHOWS_LABELS_SUSC = ['susc', 'free'];
export const SUPPORTED_STREAM = {
  chrome: ['dashwv', 'dashwv_ma'],
  opera: ['dashwv', 'dashwv_ma'],
  firefox: ['dashwv', 'dashwv_ma'],
  safari: ['hls', 'hlsfps', 'hls_ma', 'hlsfps_ma'],
  ie: ['smooth_streaming', 'smooth_streaming_ma'],
  edge: ['hls', 'dashpr', 'hls_ma', 'dashpr_ma'],
};

export const VENDORS_DEMO = {
  FOX: 'FOX PREMIUM',
  AMCO: 'Claro video',
  HBO: 'HBO',
};
export const VENDORS_BODY_DEMO = {
  FOX:
    '¡Suscribete ahora a FOX PREMIUM! Disfruta estrenos, series exclusivas y más. Precio especial $139 mensual durante 6 meses, después $175 mensual.',
  AMCO:
    'Vive la experiencia Claro video, por $69.00 al mes y accede a miles de películas, series, conciertos, documentales y la mejor programación infantil.<br>El cargo se verá reflejado en el medio de pago que elijas.<br>Si eres cliente Infinitum o Telcel ¡tu primer mes es GRATIS!',
};
export const VENDORS_FOOTER_DEMO = {
  FOX:
    'El cargo se verá reflejado en el medio de pago que elijas. Si deseas cancelar el servicio deberas hacerlos 24 horas antes de la fecha de vencimiento.',
  AMCO:
    '*Recuerda que tu suscripción se renovará automáticamente. Si deseas cancelar el servicio deberás hacerlo 24 horas antes de la fecha de vencimiento. De esta manera evitarás que se te deduzcan nuevos cargos.',
};

export const GATEWAYS_DEMO = {
  plazavipgate: 'tarjeta de crédito',
  telmexmexicogate: 'recibo TELMEX',
  hubgate: 'teléfono móvil',
  promogate: 'codigo promocional',
  itunesgate: 'itunes',
};

// DEPRECADAS, usar la configuración de la llave metadata.layout_node_configuration
export const foxNodes = ['playandgomx', 'playandgo', 'playandgohbo'];

export const defaultProductEncodesConfiguration = {
  subscrition: {
    CV_MENSUAL: {
      encodes: [
        'hls',
        'hlsfps',
        'hlsprm',
        'est_sd',
        'est_hd',
        'smooth_streaming',
        'dashpr',
        'dashwv',
      ],
    },
    CV_SEMANAL: {
      encodes: [
        'hls',
        'hlsfps',
        'hlsprm',
        'est_sd',
        'est_hd',
        'smooth_streaming',
        'dashpr',
        'dashwv',
      ],
    },
    FOX: {
      encodes: ['smooth_streaming', 'dashwv', 'widevine_classic'],
    },
    HBO: {
      encodes: [
        'hlsfps',
        'hlsfps_ma',
        'smooth_streaming',
        'smooth_streaming_ma',
        'dashwv',
        'dashwv_ma',
      ],
    },
    NOGGIN: {
      encodes: [
        'hls',
        'hlsfps',
        'hls_ma',
        'hlsfps_ma',
        'hlsprm',
        'est_sd',
        'est_hd',
        'smooth_streaming',
        'smooth_streaming_ma',
        'dashpr',
        'dashwv',
        'dashwv_ma',
        'dashpr_ma',
      ],
    },
    INDYCAR: {
      encodes: [
        'hls',
        'hlsfps',
        'hlsprm',
        'est_sd',
        'est_hd',
        'smooth_streaming',
        'dashpr',
        'dashwv',
      ],
    },
    EDYE: {
      encodes: [
        'hls',
        'hlsfps',
        'hlsprm',
        'est_sd',
        'est_hd',
        'smooth_streaming',
        'dashpr',
        'dashwv',
      ],
    },
    CRACKLE: {
      encodes: ['hlsfps', 'smooth_streaming', 'dashpr', 'dashwv'],
    },
  },
};

export const CAROUSEL = {
  ACTIVIDAD_RECIENTE: 'ACTIVIDADRECIENTE',
  CONTINUA_VIENDO: 'CONTINUAVIENDO',
  COMPRADOS_RENTADOS: 'COMPRADOSRENTADOS',
  COMPRADOS_Y_RENTADOS: 'COMPRADOSYRENTADOS',
  MIS_PROGRAMAS_GRABADOS: 'MISPROGRAMASGRABADOS',
  POR_GRABAR: 'PORGRABAR',
  MI_LISTA: 'MILISTA',
  POR_VER: 'PORVER',
  PARA_TI: 'PARATI',
  RECOMENDADOR_1: 'RECOMENDADOR1',
  RECOMENDADOR_2: 'RECOMENDADOR2',
  RECOMENDADOR_3: 'RECOMENDADOR3',
};

export const OFFER_TYPES = {
  DOWNLOAD_RENT: 'download_rent',
  DOWNLOAD_BUY: 'download_buy',
  SUBSCRIPTION: 'subscription',
  SUSCRIPTION: 'subscrition', // VIENE MAL DEL EPG ¬¬
  RENT: 'rent',
};

export const USER_MODES = {
  nav_freemium_not_logged: 'freemium',
  nav_freemium_logged: 'freemium_logueado',
  nav_premium: 'premium',
};

export const BAD_RESPONSE_ERROR_MSG = 'bad_response_error_msg';

export const PLAYER_SEGMENT = '/watch/';

export const URL_PAHTS = {
  MY_COMTENT: 'micontenido',
  HOMEUSER: 'homeuser',
};

export const CODE_MENU = {
  CONTENIDO: 'contenido',
  INICIO: 'homeuser',
};

export const PLACEHOLDERS = {
  RECIENVISTO: 'RecienVisto',
  MISCANALES_FAVORITOS: 'MisCanalesFavoritos',
  RECORDINGS: 'Recordings',
  PORGRABAR: 'PorGrabar',
  RENTAS: 'Rentas',
  PORVER: 'PorVer',
};

export const NAMES_CAROUSEL_MY_CONTEINER = {
  MIS_GRABACIONES: 'Mis-grabaciones',
  POR_GRABAR: 'Por-grabar',
};

export const STATUS_RECORDINGS = {
  INGESTED: 'ingested',
};

export const PUSHTOHISTORY = { value: true };
